// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDto } from './IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDto';
import {
    IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSON,
    IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSONTyped,
    IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSON,
    IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSONTyped,
} from './IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDto';
import type { IParticipantAccountActivityMultiEmployersSummaryRecordDto } from './IParticipantAccountActivityMultiEmployersSummaryRecordDto';
import {
    IParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSON,
    IParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSONTyped,
    IParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSON,
    IParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSONTyped,
} from './IParticipantAccountActivityMultiEmployersSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryDtoParticipantAccountActivityMultiEmployersSummaryRecordDto
 */
export interface IReportSummaryDtoParticipantAccountActivityMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryDtoParticipantAccountActivityMultiEmployersSummaryRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {Array<IParticipantAccountActivityMultiEmployersSummaryRecordDto>}
     * @memberof IReportSummaryDtoParticipantAccountActivityMultiEmployersSummaryRecordDto
     */
    employer_records?: Array<IParticipantAccountActivityMultiEmployersSummaryRecordDto>;
    /**
     * 
     * @type {Array<IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDto>}
     * @memberof IReportSummaryDtoParticipantAccountActivityMultiEmployersSummaryRecordDto
     */
    subsidiary_groups?: Array<IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryDtoParticipantAccountActivityMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryDtoParticipantAccountActivityMultiEmployersSummaryRecordDto(value: object): value is IReportSummaryDtoParticipantAccountActivityMultiEmployersSummaryRecordDto {
    return true;
}

export function IReportSummaryDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSON(json: any): IReportSummaryDtoParticipantAccountActivityMultiEmployersSummaryRecordDto {
    return IReportSummaryDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryDtoParticipantAccountActivityMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'employer_records': json['employer_records'] == null ? undefined : ((json['employer_records'] as Array<any>).map(IParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSON)),
        'subsidiary_groups': json['subsidiary_groups'] == null ? undefined : ((json['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSON(json: any): IReportSummaryDtoParticipantAccountActivityMultiEmployersSummaryRecordDto {
    return IReportSummaryDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSONTyped(value?: IReportSummaryDtoParticipantAccountActivityMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employer_name': value['employer_name'],
        'employer_records': value['employer_records'] == null ? undefined : ((value['employer_records'] as Array<any>).map(IParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSON)),
        'subsidiary_groups': value['subsidiary_groups'] == null ? undefined : ((value['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSON)),
    };
}

